import {ThemeColorName} from '../../theme';
import {ToggleKind} from './types';

type ToggleLayoutMapType = {
  [kind in ToggleKind]: {
    backgroundColor?: ThemeColorName;
    borderColor?: ThemeColorName;
    foregroundColor: ThemeColorName;
  };
};

export const OnToggleLayoutMap: ToggleLayoutMapType = {
  Disabled: {
    backgroundColor: 'background_positive_light',
    foregroundColor: 'background_mono_primary',
  },
  Active: {
    backgroundColor: 'background_positive_default',
    foregroundColor: 'background_mono_primary',
  },
};

export const OffToggleLayoutMap: ToggleLayoutMapType = {
  Disabled: {
    borderColor: 'border_mono_10',
    foregroundColor: 'content_mono_disabled',
  },
  Active: {
    borderColor: 'border_mono_30',
    foregroundColor: 'content_mono_secondary',
  },
};
